import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["comment"]

  toggleSubmit() {
    const submit = this.element.closest(".ui-modal").querySelector("[data-submit-target]")
    if (submit) {
      submit.disabled = this.commentTarget.value.trim().length === 0
    }
  }
}
